"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* tslint:disable */

/* eslint-disable */

/*
query MobileFollowArtistButtonQuery(
  $artistId: String!
) {
  artist(id: $artistId) {
    ...FollowArtistButton_artist
    id
  }
}

fragment FollowArtistButton_artist on Artist {
  id
  internalID
  name
  slug
  is_followed: isFollowed
  counts {
    follows
  }
}
*/
var node = function () {
  var v0 = [{
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "artistId",
    "type": "String!"
  }],
      v1 = [{
    "kind": "Variable",
    "name": "id",
    "variableName": "artistId"
  }];
  return {
    "fragment": {
      "argumentDefinitions": v0
      /*: any*/
      ,
      "kind": "Fragment",
      "metadata": null,
      "name": "MobileFollowArtistButtonQuery",
      "selections": [{
        "alias": null,
        "args": v1
        /*: any*/
        ,
        "concreteType": "Artist",
        "kind": "LinkedField",
        "name": "artist",
        "plural": false,
        "selections": [{
          "args": null,
          "kind": "FragmentSpread",
          "name": "FollowArtistButton_artist"
        }],
        "storageKey": null
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0
      /*: any*/
      ,
      "kind": "Operation",
      "name": "MobileFollowArtistButtonQuery",
      "selections": [{
        "alias": null,
        "args": v1
        /*: any*/
        ,
        "concreteType": "Artist",
        "kind": "LinkedField",
        "name": "artist",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "internalID",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }, {
          "alias": "is_followed",
          "args": null,
          "kind": "ScalarField",
          "name": "isFollowed",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "concreteType": "ArtistCounts",
          "kind": "LinkedField",
          "name": "counts",
          "plural": false,
          "selections": [{
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "follows",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }]
    },
    "params": {
      "id": null,
      "metadata": {},
      "name": "MobileFollowArtistButtonQuery",
      "operationKind": "query",
      "text": "query MobileFollowArtistButtonQuery(\n  $artistId: String!\n) {\n  artist(id: $artistId) {\n    ...FollowArtistButton_artist\n    id\n  }\n}\n\nfragment FollowArtistButton_artist on Artist {\n  id\n  internalID\n  name\n  slug\n  is_followed: isFollowed\n  counts {\n    follows\n  }\n}\n"
    }
  };
}();

node.hash = 'e249ef453f7f1400e7405137c158d6c1';
var _default = node;
exports.default = _default;
//# sourceMappingURL=MobileFollowArtistButtonQuery.graphql.js.map